import { JUGUANG_MCP_SERVER_NAME } from "./enterprise-credentials.js";
import { DOSIA_PROJECTS_MCP_SERVER_NAME } from "./projects-mcp-contract.js";
/**
 * Enterprise plugins that are invisible and unusable unless the current role
 * explicitly grants them through RoleWorkspaceConfig.managedPlugins.
 *
 * `dosia-projects` 在名单里，管的是**会话可见性**：角色没被授予，桌面会话和云端
 * 任务就不挂这个连接器。它自 N-76 起只剩一个只读工具 `project_list`。谁能签出身份
 * token 不看这张名单（N-201）：飞书里可见性按机器人的角色判、签发按提问人的角色判，
 * 所以 apps/web/server/enterprise/projects-identity-token.ts 只看 forbiddenPlugins。
 *
 * `dosia-relay` **刻意不在**这张名单里（REQ-220 定稿）：建云端任务、提交知识这些
 * 事对全体企业成员开放，服务端 facade 里的 canApproveSkill / requireAdmin 才是那
 * 几个写动作的门。判据见 apps/web/server/enterprise/relay-identity-token.ts —— 把它
 * 加进来，没配授权的员工连身份 token 都签不出来，九个工具当场全灭。
 */
export const EXPLICIT_GRANT_ONLY_ENTERPRISE_PLUGINS = Object.freeze([
    JUGUANG_MCP_SERVER_NAME,
    DOSIA_PROJECTS_MCP_SERVER_NAME,
]);
const explicitGrantOnlyEnterprisePlugins = new Set(EXPLICIT_GRANT_ONLY_ENTERPRISE_PLUGINS);
export function isExplicitGrantOnlyEnterprisePlugin(pluginName) {
    return explicitGrantOnlyEnterprisePlugins.has(pluginName);
}
/**
 * Single enterprise plugin entitlement predicate.
 *
 * forbiddenPlugins is always the final denial. In personal/dev mode, the
 * explicit-grant-only policy does not apply. In enterprise mode, restricted
 * plugins require an exact managedPlugins grant; ordinary plugins retain their
 * existing tag/scope visibility.
 */
export function isEnterprisePluginEntitled(input) {
    if (input.forbiddenPlugins?.includes(input.pluginName))
        return false;
    if (input.deployMode !== "enterprise")
        return true;
    if (!isExplicitGrantOnlyEnterprisePlugin(input.pluginName))
        return true;
    return input.managedPlugins?.includes(input.pluginName) === true;
}
//# sourceMappingURL=enterprise-plugin-entitlement.js.map